import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c265d658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard__menu" }
const _hoisted_2 = { class: "card__inner" }

import { BasicCard } from '@components/basic';
import { IonImg, IonText } from '@ionic/vue'
import menuItems from '@/router/menu'


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardMenu',
  setup(__props) {

const tiles = menuItems.filter(tile => !tile.meta.hideInDashboard);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tiles), (tile, index) => {
      return (_openBlock(), _createBlock(_unref(BasicCard), {
        shape: "square",
        class: "dashboard__card",
        key: `${tile.label}_${index}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: tile.route
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(IonImg), {
                  src: tile.image,
                  alt: " ",
                  class: "card__icon",
                  width: "120",
                  height: "120"
                }, null, 8, ["src"]),
                _createVNode(_unref(IonText), {
                  color: "primary",
                  class: "ion-text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(tile.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})